import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'orderDataKey',
  standalone: true,
  pure: false // Hacer el pipe impuro para que se actualice con cambios de idioma
})
export class OrderDataKeyPipe implements PipeTransform {

  constructor(private translateService: TranslateService) {}

  transform(key: string): string {
    const translationKey = `ORDER_DATA_KEYS.${key}`;
    const translated = this.translateService.instant(translationKey);
    
    // Si la traducción no existe, devolver la clave original
    return translated !== translationKey ? translated : key;
  }
}